module.exports = __webpack_public_path__ + "static/media/potter.10e7a424.png";